import { queryApi } from '../../../api'
import { ENDPOINT } from '../../../constants'
import {
  IFordelingInformasjon,
  IKvitteringData,
  ITilsynstype,
  kvitteringStatusEnum,
} from '../../../ducks/kvittering/types'
import { IQueryApiResponse } from '../../../common/types'
import {
  ICreateKvitteringPayload,
  IFordelKvitteringTilKollegaPayload,
  IHentKvitteringerFraKollegaPayload,
  IUpdateKvitteringPayload,
} from '../types'
import { createQueryStringFromObject } from '../../../common/createQueryStringFromObject'

interface IGetKvitteringOptions {
  signal?: AbortSignal
}

export const kvitteringApi = {
  get: (id: string, options?: IGetKvitteringOptions) =>
    queryApi.get<IKvitteringData>(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/${id}?expand=tilsynsobjekter,kontrollpunkter,observasjoner,bildeIds,veiledninger,andreDeltagere,mattilsynetDeltagere,virksomhetsDeltagere`,
      { signal: options?.signal }
    ),
  getSammenstilling: (url: string, options?: IGetKvitteringOptions) =>
    queryApi.get<IKvitteringData>(url, { signal: options?.signal }),
  getTilsynstyper: (options?: IGetKvitteringOptions) =>
    queryApi.get<IQueryApiResponse<{ tilsynstypeList: ITilsynstype[] }>>(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/tilsynstyper`,
      { signal: options?.signal }
    ),
  getIkkeFerdigstilteKvitteringer: () => {
    const NOT_FERDIGSTILTE_KVITTERINGER_QUERIES = createQueryStringFromObject(
      '?'
    )({
      'sort.direction': 'DESC',
      'sort.property': 'oppdatert',
      'filter.not.status': [
        kvitteringStatusEnum.FERDIGSTILT,
        kvitteringStatusEnum.FERDIGSTILLING_PAAGAAR,
      ],
      'page.size': '100',
    })

    const NOT_FERDIGSTILTE_KVITTERINGER_URL = `${ENDPOINT.TILSYNSKVITTERING}/completetilsynskvitteringer/${NOT_FERDIGSTILTE_KVITTERINGER_QUERIES}`

    return queryApi.get<IQueryApiResponse<{ kvitteringer: IKvitteringData[] }>>(
      NOT_FERDIGSTILTE_KVITTERINGER_URL
    )
  },
  getFerdigstilteKvitteringer: () => {
    const FERDIGSTILTE_KVITTERINGER_QUERIES = createQueryStringFromObject('?')({
      'sort.direction': 'DESC',
      'sort.property': 'oppdatert',
      'filter.has.status': [
        kvitteringStatusEnum.FERDIGSTILT,
        kvitteringStatusEnum.FERDIGSTILLING_PAAGAAR,
      ],
      'page.size': '50',
    })

    const FERDIGSTILTE_KVITTERINGER_URL = `${ENDPOINT.TILSYNSKVITTERING}/completetilsynskvitteringer/${FERDIGSTILTE_KVITTERINGER_QUERIES}`

    return queryApi.get<IQueryApiResponse<{ kvitteringer: IKvitteringData[] }>>(
      FERDIGSTILTE_KVITTERINGER_URL
    )
  },
  getFordelingInformasjon: (id: string) =>
    queryApi.get<IQueryApiResponse<{ fordelinger: IFordelingInformasjon[] }>>(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/fordeling/${id}`
    ),
  post: (payload: ICreateKvitteringPayload) =>
    queryApi.post(`${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer`, payload),
  put: ({ kvittering }: IUpdateKvitteringPayload) =>
    queryApi.put(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/${kvittering.id}`,
      kvittering
    ),
  delete: async (kvitteringId: string) =>
    queryApi.delete(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/${kvitteringId}`
    ),
  fordel: async (
    kvitteringId: string,
    { ansatt }: IFordelKvitteringTilKollegaPayload
  ) =>
    queryApi.post(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/fordeling/${kvitteringId}/${ansatt.brukernavn}`,
      {}
    ),
  overta: async ({
    begrunnelse,
    kvitteringIds,
  }: IHentKvitteringerFraKollegaPayload) =>
    queryApi.post(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/overtagelse`,
      { begrunnelse, tilsynskvitteringIds: kvitteringIds }
    ),
  arkiver: async (kvitteringId: string) =>
    queryApi.put(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/${kvitteringId}/arkiver`,
      {}
    ),
  ferdigstill: async (kvitteringId: string) =>
    queryApi.put(
      `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/${kvitteringId}/ferdigstill`,
      {}
    ),
}
